// const baseURL = process.env.API_URL;
import "core-js/actual/structured-clone";
import { OBTAIL_URL, REFRESH_URL } from "../pages/params";

/**
 * @param {Object} obj1
 * @param {Object} obj2
 */
const updateObject = (obj1, obj2) => {
    let result = structuredClone(obj1);
    for (var prop in obj2) {
        // Property in destination object set.
        if (!(prop in result)) {
            result[prop] = structuredClone(obj2[prop]);
            continue;
        }
        if (obj2[prop].constructor == Object) {
            result[prop] = updateObject(result[prop], obj2[prop]);
        } else {
            result[prop] = obj2[prop];
        }
    }
    return result;
};

/**
 *
 * @param {String} url
 * @param {Object} options
 * @returns {Promise<Response>}
 */
export const authFetch = async (url, options) => {
    const accessToken = localStorage.getItem("access_token");
    const authHeader = {
        headers: { Authorization: accessToken ? "JWT " + accessToken : "" },
    };
    const optionsWithAuth = updateObject(options, authHeader);
    let response = await fetch(url, optionsWithAuth);
    if (response.status == 401) {
        const refreshResult = await refreshToken();
        if (refreshResult == 0) {
            return authFetch(url, options);
        }
        return;
    }
    return response;
};
/**
 * @param {String} accessToken
 * @param {String} refreshToken
 */
export const setTokens = (accessToken, refreshToken) => {
    localStorage.setItem("access_token", accessToken);
    localStorage.setItem("refresh_token", refreshToken);
};
/**
 * @param {String} username
 * @param {String} password
 */
export const obtainToken = async (username, password) => {
    const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith("csrftoken="))
        ?.split("=")[1];
    await fetch("/admin/login/", {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        redirect: "manual",
        body:
            "username=" +
            username +
            "&password=" +
            password +
            "&csrfmiddlewaretoken=" +
            cookieValue,
    });
    const response = await fetch(OBTAIL_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: username, password: password }),
    });

    if (!response.ok) {
        throw {
            status: response.status,
            statusText: response.statusText,
        };
    } else {
        const body = await response.json();
        setTokens(body["access_token"], body["refresh_token"]);
        console.log(response.body);
        return body;
    }
    // if (response.status === 401) {
    //     console.log(response);
    //     throw new Error(response.statusText);
    // }
    // throw new Error("Unknown error");
};

export const refreshToken = async () => {
    const refreshToken = localStorage.getItem("refresh_token");
    if (refreshToken == null) {
        newLogin();
        return 1;
    }
    const response = await fetch(REFRESH_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refresh_token: refreshToken }),
    });
    if (!response.ok) {
        newLogin();
        return 1;
    }
    const body = await response.json();
    setTokens(body["access_token"], body["refresh_token"]);
    return 0;
};
export const newLogin = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    window.location.href = "/login/";
};
export async function logout() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    await fetch("/admin/logout/", {
        method: "GET",
    });
    // TODO: invalidate token on backend
}

export const isAuthenticated = () => {
    const token = localStorage.getItem("access_token");
    return !!token;
};

export const isAdmin = () => {
    const token = localStorage.getItem("access_token");
    return !!token;
};
